import { render } from "./RecentDetails.vue?vue&type=template&id=278b864c&scoped=true&ts=true"
import script from "./RecentDetails.vue?vue&type=script&lang=ts"
export * from "./RecentDetails.vue?vue&type=script&lang=ts"

import "./RecentDetails.vue?vue&type=style&index=0&id=278b864c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278b864c"]])

export default __exports__